import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';
import { Root, createRoot } from 'react-dom/client';
import { ViewCreateNewMessage } from '../../../patient/src/views/view_create_new_message/view_create_new_message.component';
import { Route, Routes } from 'react-router';
import { sharedResolution } from '@public/src/shared_resolution';
import { LocationSelectorService } from '@public/src/application/services/location_selector.service';
import { OutletPage } from '@component/outlet_page.component';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { UniversalConfig } from '@application/universal_config.service';
import { PatientFlowContainer } from '@public/src/components/patient_flow_container.component';

const containerElementName = 'CreateNewMessageComponent';
const FULL_HEIGHT_CLASS_NAME = 'js-fullHeight';

@Component({
	standalone: false,
	styleUrls: ['./css/create-new-message.wrapper.scss'],
	selector: 'create-new-message-component',
	template: ` <semantic-view hideOnMobile="true">
		<header-component header></header-component>

		<div class="wrapper-container" #${containerElementName}></div>

		<footer-component footer></footer-component>
	</semantic-view>`,
	encapsulation: ViewEncapsulation.None,
})
export class CreateNewMessageWrapper implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(private readonly ngZone: NgZone) {
		// Empty
	}

	ngAfterViewInit() {
		document.body.classList.add(FULL_HEIGHT_CLASS_NAME);
		this.render();
	}

	ngOnDestroy() {
		document.body.classList.remove(FULL_HEIGHT_CLASS_NAME);
		this.root?.unmount();
	}

	private async render() {
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		const universalConfigService = sharedResolution.resolve(UniversalConfig);

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const split = locationSelectorService.location.route.split('/');
		split.splice(0, 1);
		const routeBase = split.join('/');

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<PatientFlowContainer>
						<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
							<Routes>
								<Route path={routeBase} element={<OutletPage />}>
									<Route path='message/*' element={<ViewCreateNewMessage />} />
								</Route>
							</Routes>
						</ProgrammaticBrowserRouter>
					</PatientFlowContainer>
				</CellulaProviderWrapper>,
			);
		});
	}
}
